import { getAxios } from './axios.service';

const urlServiceGarde = 'api/ICSG/ServiceGarde';
const urlMenu = 'api/ICSG/Menu';

export function obtenirServiceGarde() {
    const url = new URL(window.location);
    if (url.pathname.startsWith('/Apps/ICSG/')) {
        url.pathname = '/Apps/ICSG/' + urlServiceGarde;
    }
    else {
        url.pathname = urlServiceGarde;
    }
    return getAxios(url);
}

export function obtenirMenu() {
    const url = new URL(window.location);
    if (url.pathname.startsWith('/Apps/ICSG/')) {
        url.pathname = '/Apps/ICSG/' + urlMenu;
    }
    else {
        url.pathname = urlMenu;
    }
    return getAxios(url);
}
